import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { updateCleSubscriptionCache } from "../../../services/api/serviceMessaging.api";
import { useSnackbar } from "notistack";
import { showSnack } from "../../../utils/component";

/**
 * This component displays service message actions
 */
export const ServiceMessaging = () => {
	const { enqueueSnackbar } = useSnackbar();
	const [isUpdatingCache, setIsUpdatingCache] = useState(false);

	const updateCacheHandler = async () => {
		setIsUpdatingCache(true);

		try {
			const result = await updateCleSubscriptionCache()();
			if (result.data) {
				showSnack(enqueueSnackbar, "Cache updated successfully");
			} else {
				showSnack(enqueueSnackbar, "Updating cache failed", "error");
			}
		} catch {
			showSnack(enqueueSnackbar, "Updating cache failed", "error");
		}

		setIsUpdatingCache(false);
	};

	return (
		<div>
			<Button variant="outlined" disabled={isUpdatingCache} onClick={updateCacheHandler}>
				Update CLE Subscription Cache
			</Button>
		</div>
	);
};
